module.exports = __webpack_public_path__ + "assets/img/soft17.b2e2fc54.jpg";